<template>
    <div>
        <b-card :title="title">
            <b-tabs card>
                <b-tab :title="assetName" active>
                    <b-card-body>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-row align-h="center">
                                <b-col
                                    v-for="n in 2"
                                    :key="n + 'type'"
                                    cols="12"
                                    md="6"
                                >
                                    <b-form-group
                                        v-for="(d_item, i) in formFields[
                                            n == 1 ? 'evenList' : 'oddList'
                                        ]"
                                        :key="`${n} type ${i} group`"
                                        :id="d_item.field"
                                        :label="getLabel(d_item, true)"
                                        :label-for="'input-' + d_item.field"
                                        label-class="font-weight-bold pt-0"
                                    >
                                        <location-section
                                            ref="locationSection"
                                            v-model="model.location_section_id"
                                            @update-section-model="
                                                x => (locationData = x)
                                            "
                                            :hide-controls="true"
                                            :disabled="isView"
                                            v-if="
                                                d_item.field ==
                                                'location_section_id'
                                            "
                                            title=""
                                            modal-title="Location"
                                            :is-modal="true"
                                        >
                                            <template
                                                #default="{
                                                    setSearchMode,
                                                    hideModal,
                                                }"
                                            >
                                                <b-button
                                                    v-show="!isView"
                                                    @click="setSearchMode()"
                                                    v-if="hasPermissionUpdate"
                                                    variant="secondary"
                                                    >Change Location</b-button
                                                >
                                                <b-button
                                                    class="mr-2"
                                                    variant="warning"
                                                    @click="hideModal()"
                                                    >Cancel</b-button
                                                >

                                                <b-button
                                                    class="mr-2"
                                                    variant="primary"
                                                    :disabled="loading"
                                                    v-show="hasPermissionView"
                                                    @click="isView = !isView"
                                                    >{{
                                                        isView ? 'Edit' : 'View'
                                                    }}</b-button
                                                >
                                            </template>
                                        </location-section>

                                        <select-order-template
                                            v-else-if="
                                                d_item.field ==
                                                'order_template_id'
                                            "
                                            v-model="model[d_item.field]"
                                            :toggle-active="!crm"
                                            :disabled="isView"
                                            include-order-type
                                            :is-required="crm"
                                        />
                                        <customer-type-ahead
                                            v-else-if="
                                                d_item.field == 'customer_id'
                                            "
                                            :key="locationRefreshCounter"
                                            v-model="model[d_item.field]"
                                            :disabled="isView"
                                        />

                                        <contact-selection
                                            v-else-if="
                                                d_item.field ==
                                                'customer_contact_id'
                                            "
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :disabled="
                                                isView || !model.customer_id
                                            "
                                            :customer_id="model.customer_id"
                                        >
                                            {{ `Select ${getLabel(d_item)}` }}
                                        </contact-selection>

                                        <b-form-select
                                            v-else-if="d_item.type === 'select'"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :options="getOptions(d_item.field)"
                                            :disabled="
                                                isView ||
                                                is_one_off_linked(d_item.field)
                                            "
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >{{
                                                        `Select ${getLabel(
                                                            d_item
                                                        )}`
                                                    }}</b-form-select-option
                                                >
                                            </template>
                                        </b-form-select>

                                        <link-modal
                                            v-else-if="d_item.type === 'url'"
                                            v-model="model[d_item.field]"
                                            :key="model[d_item.field]"
                                            :disabled="isView"
                                        ></link-modal>

                                        <b-form-textarea
                                            :disabled="isView"
                                            v-else-if="
                                                d_item.type === 'textarea'
                                            "
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :placeholder="`Enter ${getLabel(
                                                d_item
                                            )}`"
                                            rows="3"
                                            max-rows="6"
                                        ></b-form-textarea>

                                        <b-form-input
                                            :disabled="
                                                isView ||
                                                is_one_off_linked(d_item.field)
                                            "
                                            v-else
                                            :type="d_item.type"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :placeholder="`Enter ${getLabel(
                                                d_item
                                            )}`"
                                            trim
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col>
                                    <b-button-group size="sm">
                                        <b-button
                                            variant="secondary"
                                            :disabled="!!loading"
                                            @click="$router.go(-1)"
                                            >Cancel</b-button
                                        >
                                        <b-button
                                            v-if="this.model.id"
                                            v-show="hasPermissionDelete"
                                            @click="deleteAsset()"
                                            variant="warning"
                                        >
                                            {{
                                                `${
                                                    deleting
                                                        ? 'Deleting'
                                                        : 'Delete'
                                                } ${assetName}`
                                            }}
                                        </b-button>
                                        <b-button
                                            v-if="!!model.id"
                                            variant="primary"
                                            :disabled="loading"
                                            v-show="hasPermissionView"
                                            @click="isView = !isView"
                                            >{{
                                                isView ? 'Edit' : 'View'
                                            }}</b-button
                                        >
                                        <b-button
                                            variant="primary"
                                            :disabled="loading"
                                            type="submit"
                                            v-if="!isView"
                                        >
                                            <b-spinner
                                                v-show="loading"
                                                label="Spinning"
                                                v-if="hasPermissionUpdate"
                                            ></b-spinner>
                                            {{ model.id ? 'Update' : 'Create' }}
                                        </b-button>
                                    </b-button-group>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-tab>
                <!-- <b-tab title="Master Items" :disabled="!isView">
                    <b-card-body>
                        <b-table
                            responsive
                            :items="masterItems"
                            :fields="master_fields"
                        >
                            <template #cell(id)="row">
                                <b-button
                                    size="sm"
                                    :to="`/admin/master-items/${row.item.id}`"
                                    class="mr-2"
                                    variant="primary"
                                    v-if="hasPermissionView"
                                >
                                    View
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab> -->
                <b-tab title="Service History" :disabled="!isView">
                    <b-card-body>
                        <b-table
                            responsive
                            :items="asset_orders"
                            :fields="asset_order_fields"
                        >
                            <template #cell(id)="{ item: order, index }">
                                <b-button
                                    :key="index + 'rootbutton'"
                                    size="sm"
                                    :to="`/admin/orders/${order.id}`"
                                    class="mr-2"
                                    variant="primary"
                                    v-if="hasPermissionView"
                                >
                                    View Activity
                                </b-button>
                            </template>

                            <template #cell(driver_id)="{ value }">
                                {{ getOfficerName(value) }}
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead'

import SelectOrderTemplate from '@/components/SelectOrderTemplate'

import assetMixins from '@/mixins/assetMixins'
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

import permissionsMixins from '@/mixins/permissionsMixins'

import LocationSection from '@/views/Location/LocationSection'
import LinkModal from '@/components//LinkModal'
import ContactSelection from '@/components/ContactSelection.vue'
import moment from 'moment'

const dataItems = [
    //mandatory  but must be automated
    { field: 'name', type: 'text', required: true },
    { field: 'type_id', type: 'select', required: true },

    //optional that will be ignored
    { field: 'serial_no', type: 'text' },
    { field: 'model_no', type: 'text' },
    { field: 'description', type: 'text' },

    { field: 'manufacturer_id', type: 'select', required: true },

    { field: 'customer_id', type: 'custom', required: true },
    { field: 'customer_contact_id', type: 'custom', required: false },
    { field: 'location_section_id', type: 'custom', required: true },

    { field: 'vendor_id', type: 'select', required: true },

    { field: 'manual_url', type: 'url' },
    { field: 'service_plan_url', type: 'url' },
    { field: 'image_url', type: 'url' },
    { field: 'warranty_expiry_date', type: 'date' },
    { field: 'last_service_date', type: 'date' },
    { field: 'next_service_date', type: 'date' },
    { field: 'frequency', type: 'select', required: true },

    ///////////  new fields
    { field: 'service_week_day', type: 'select', required: false },
    { field: 'service_time_of_day', type: 'time', required: false },
    { field: 'contract_expiry_date', type: 'date', required: false },
    { field: 'default_engineer_id', type: 'select', required: false },
    { field: 'notes', type: 'textarea' },
    { field: 'order_template_id', type: 'custom', required: false },
    //
]

const crm_fields = [
    { field: 'name', label: 'Name' },
    { field: 'customer_id', label: 'Customer' },
    { field: 'customer_contact_id', required: false },
    { field: 'location_section_id', label: 'Customer Address' },
    { field: 'default_engineer_id', label: 'Agent', required: true },
    { field: 'frequency', label: 'Frequency' },
    { field: 'last_service_date', label: 'Last Visit' },
    { field: 'next_service_date', label: 'Next Visit' },
    { field: 'service_week_day', label: 'Week Day' },
    { field: 'service_time_of_day', label: 'Time of Day' },
    { field: 'contract_expiry_date', label: 'Expiry Date', required: true },
    { field: 'order_template_id', required: true },
    { field: 'notes' },
]

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            _form[item.field] = null
            return _form
        },
        { id: 0 }
    )
}

const model = generateEmptyForm()
export default {
    name: 'assets-ViewItem',

    components: {
        LocationSection,
        LinkModal,
        CustomerTypeAhead,
        SelectOrderTemplate,
        ContactSelection,
    },
    mixins: [popupMixins, assetMixins, utilityMixins, permissionsMixins],

    data() {
        return {
            asset_order_visible_array: [...Array(1000).keys()].map(() => false),

            deleting: false,
            locationData: {},
            newMasterItem: null,
            isError: false,
            locationRefreshCounter: 0,
            locationState: false,
            componentName: 'Asset',
            model,
            loading: false,
            hasErrors: false,
            isView: false,
            uploadModal: false,
            master_fields: [
                {
                    key: 'id',
                    label: '',
                },
                'name',
                'description',
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => {
                        item = item || {}
                        const type = item.type || {}
                        return type.name
                    },
                },
            ],

            service_fields: [
                'name',

                {
                    key: 'order.reference_no',
                    label: 'Reference No.',
                    formatter: (value, key, item) => item.order.reference_no,
                },

                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.item_type.name,
                },

                'quantity',

                {
                    key: 'order.created_at',
                    label: 'Created',
                    formatter: (value, key, item) =>
                        new Date(item.order.created_at)
                            .toISOString()
                            .split('T')[0],
                },

                {
                    key: 'order.completed_at',
                    label: 'Completed',
                    formatter: (value, key, item) =>
                        item.order.completed_at
                            ? new Date(item.order.completed_at)
                                  .toISOString()
                                  .split('T')[0]
                            : '',
                },

                {
                    key: 'order_item_notes',
                    label: 'Notes',
                    formatter: (value, key, item) => item.task_notes, // tk: To be revisited
                },

                {
                    key: 'order_id',
                    label: '',
                },
            ],
        }
    },
    props: ['id', 'crm', 'officers', 'types'],

    computed: {
        asset_order_fields() {
            return [
                {
                    key: 'id',
                    label: '',
                },
                {
                    key: 'driver_id',
                    label: 'Assigned To',
                },

                {
                    key: 'schedule_at',
                    label: 'Due',
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },

                'description',

                {
                    key: 'completed_at',
                    label: 'Completion Date',
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },

                {
                    key: 'reference_no',
                    label: 'ReferenceNo',
                    formatter: value => value,
                },

                {
                    key: 'status',
                    label: 'State',
                    formatter: (value, key, item) =>
                        item.completed == 1
                            ? 'Completed'
                            : item.released == 1
                            ? 'Released'
                            : 'Pending',
                },
            ]
        },

        user() {
            return this.$store.state.user
        },

        formFields() {
            const list = []
            if (this.crm) {
                for (const crm_obj of crm_fields) {
                    const obj = dataItems.find(y => y.field == crm_obj.field)
                    for (const key in crm_obj) {
                        this.$set(obj, key, crm_obj[key])
                    }
                    list.push(obj)
                }
            } else {
                list.push(...dataItems)
            }
            // split in odd and even
            const typeObj = { oddList: [], evenList: [] }
            let isEven = true
            for (const item of list) {
                if (isEven) {
                    typeObj.evenList.push(item)
                } else {
                    typeObj.oddList.push(item)
                }
                isEven = !isEven
            }
            return typeObj
        },
        crmSettingValue() {
            return this.$store.getters['company/crmSettingValue']
        },
        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },

        masterItems() {
            const asset = this.asset || {}
            let master_items =
                (asset.order_template && asset.order_template.items) || []
            return master_items.map(x => x.master_item)
        },
        asset() {
            const asset = this.$store.state.assets.asset || {}
            console.log('asset', asset)
            return asset
        },
        services() {
            //return (this.asset.services || []).map(x => x.item)
            const _services = (this.asset.services || []).map(x => x.item)
            console.log('_services', _services) // tk
            return _services
        },

        asset_orders() {
            const _orders = []

            for (const item of this.services) {
                const { order } = item

                const _item = { ...item }

                delete _item.order

                let idx = _orders.findIndex(x => x.id == order.id)
                if (idx < 0) {
                    order.items = []
                    order.items.push(_item)
                    _orders.push(order)
                } else {
                    _orders[idx].items.push(_item)
                }
            }

            console.log('asset orders', _orders)

            return _orders
        },

        assetName() {
            return this.crm ? 'CRM Task' : 'Asset'
        },

        title() {
            return this.model.id
                ? `Edit ${this.assetName}`
                : `Create ${this.assetName}`
        },

        vendors() {
            return this.$store.state.assets.vendors
        },

        customers() {
            return this.$store.state.customers.items
        },

        locations() {
            return this.$store.state.locations.locations
        },
        engineers() {
            return this.$store.getters['users/sorted_officers']
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },

        customer_contacts() {
            return this.$store.getters['customers/customerUsers']
        },
    },
    watch: {
        /*
            asset_orders: {
                handler: function (arr) {
                    this.asset_order_visible_array.splice(0)
                    this.asset_order_visible_array.push(...[ ...Array(arr.length).keys() ].map(() => false))               
                },
                deep: true,
            }, */

        'model.customer_id': function (customer_id) {
            let customer = null
            console.log('watch customer_id', customer_id)
            if (!this.isView) {
                this.model.customer_contact_id = null
            }
            if (customer_id) {
                this.$store.dispatch(`customers/fetchById`, customer_id)
                customer = this.customers.find(x => x.id === customer_id)
                if (customer && customer.location_section_id) {
                    console.log('customer', customer)
                    this.model.location_section_id =
                        customer.location_section_id
                    this.locationRefreshCounter++
                }
            } else {
                this.$store.commit(`customers/SET_CUSTOMER`, null)
            }
            //////////////////////set taskname  if crm///////////////
            const {
                crm,
                model: { id, name },
            } = this
            if (crm && !id && !name && customer) {
                console.log('setting name', customer)
                const { name } = customer
                const randIdx = (Math.random() + 1).toString(36).substring(7)
                this.$set(this.model, 'name', `${name}-${randIdx}`)
            }
            ///////
        },

        locationData: {
            handler: function (to, from) {
                if (!from) return
                for (const key in to) {
                    this.$set(this.model, key, to[key])
                }
            },
            deep: true,
        },
    },
    created() {
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('js_report/fetchCredentials')
    },
    mounted() {
        console.log('view route', this.$route)
        this.$store.dispatch('company/fetchConfiguration', this.crmsettingsKey)

        this.model = generateEmptyForm()
        if (this.id) {
            this.loadAsset(this.id)
        } else {
            this.$set(this.model, 'default_engineer_id', this.user.id)
        }
    },
    methods: {
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD HH:mm'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        getOfficerName(id) {
            const officer = this.officers.find(x => x.id == id)
            if (!officer) return ''
            return officer.name
        },
        do_toggle(index) {
            console.log(index)
            console.log(this.asset_order_visible_array[index])
            this.asset_order_visible_array[index] =
                !this.asset_order_visible_array[index]
        },
        is_one_off_linked(key) {
            const checkKeys = [
                'last_service_date',
                'contract_expiry_date',
                'service_week_day',
            ]
            const isIncluded = key => {
                const _is_included = checkKeys.includes(key)
                console.log({ key, _is_included })
                return _is_included
            }
            return this.model.frequency == '0' && isIncluded(key)
        },

        IntToTimeFormat(intValue) {
            const formatInt = _int => {
                if (_int < 10) _int = `0${_int}`
                else _int = _int.toString()
                return _int
            }
            let hours = parseInt(intValue / 60, 10)
            if (hours > 23 || hours < 0) hours = 0
            let minutes = intValue - hours * 60

            return `${formatInt(hours)}:${formatInt(minutes)}`
        },
        TimeFormatToInteger(_time) {
            try {
                const [hours, minutes] = _time.split(':')
                return parseInt(hours) * 60 + parseInt(minutes)
            } catch (err) {
                return null
            }
        },

        async loadAsset(id) {
            this.loading = true
            this.isView = true
            try {
                await this.$store.dispatch('assets/get', id)
                await this.$nextTick()

                const { asset } = this
                console.log('loadAsset asset', asset)
                this.model = { ...asset }
                /*  for (const key in this.asset) {
                     let value = this.asset[key]
                     if (key === 'service_time_of_day') {
                     value = this.IntToTimeFormat(value)
                     }
                     this.$set(this.model, key, value)
                     } */

                this.$set(
                    this.model,
                    'service_time_of_day',
                    this.IntToTimeFormat(asset.service_time_of_day)
                )
                console.log('loaded model', this.model)
                let { locationData } = this
                locationData = locationData || {}
                for (const key in locationData) {
                    this.$set(this.model, key, locationData[key])
                }
            } catch (error) {
                console.error(error)
                this.isError = true
            } finally {
                this.loading = false
            }
        },

        async onSubmit() {
            this.loading = true

            try {
                console.log('starting now')
                if (this.model.frequency == '0') {
                    const { next_service_date: nsd } = this.model
                    const weekday = new Date(nsd).getDay()
                    this.$set(this.model, 'contract_expiry_date', nsd)
                    this.$set(this.model, 'service_week_day', weekday)
                }
                if (this.crm) {
                    const {
                        crmSettingValue: { type_id, vendor_id },
                        model: { contract_expiry_date },
                    } = this
                    this.$set(this.model, 'type_id', type_id)
                    this.$set(this.model, 'vendor_id', vendor_id)
                    this.$set(
                        this.model,
                        'warranty_expiry_date',
                        contract_expiry_date
                    )
                    this.$set(this.model, 'manufacturer_id', vendor_id)
                }
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Invalid Entry')

                console.log('valid so far')

                const payload = {
                    ...this.model,
                }

                payload.service_time_of_day = this.TimeFormatToInteger(
                    payload.service_time_of_day
                )

                const id = parseInt(payload.id) || null
                delete payload.id

                const action = id ? 'update' : 'create'

                const path = `assets/${action}`
                console.log('submit payload', payload)
                console.log('submit path', path)
                await this.$store.dispatch(path, { id, payload })
                this.model = generateEmptyForm()

                this.$emit('success', action, this.assetName)
                this.$router.go(-1)
            } catch (error) {
                this.$emit('error', error, this.assetName)
            } finally {
                this.loading = false
            }
        },

        async deleteAsset() {
            const model = { ...this.model }
            // Generate and display confirmation prompt
            const title = `Delete ${this.assetName}?`
            const message = `Are you sure you want to delete ${model.name}?`
            const result = await this.confirmMessage(title, message)
            console.log('result', result)
            if (result) {
                try {
                    this.deleting = true
                    await this.$store.dispatch('assets/delete', model.id)
                    this.$emit('success', 'delete', this.assetName)

                    this.$router.go(-1)
                } catch (error) {
                    console.error(error)
                    this.doToast(
                        'Error!',
                        `Unable to delete!` || error.message,
                        'danger'
                    )
                } finally {
                    this.deleting = false
                }
            }
        },

        setAssetLocation({ section, location }) {
            console.log('setAssetLocation-evt', { section, location })
            const { name: section_name } = section
            location = location || section.location || {}
            this.$set(this.model, 'section_name', section_name)
            this.$set(this.model, 'location', location)
        },
    },
}
</script>
<style></style>
